export const projectTypes = {
  movie: 'movie',
  podcast: 'podcast',
  series: 'series',
  special: 'special',
}
